export default "immagini/logo-completo-semplice.svg"